import Button from "@components/base/button";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { CONTINENT_LIST } from "@core/global/global-country-dictionary";
import LocalStorageService from "@core/services/local-storage.service";
import { getInternationalNumberSystem } from "@core/utility/utility";
import { searchParametersHandler } from "@redux/Shipment/shipmentSlice";
import { appliedSelectAllHandler } from "@redux/User/userDetailsSlice";
import { isoCountries } from "@routes/intel/onboarding-screens/isoCountryCodes";
import { Suspense, lazy, useCallback, useEffect, useMemo, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { ChevronDown, ChevronUp, Info } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getUserActivePlan } from "@helpers/profileHelper";
import { useHistory, useLocation } from "react-router-dom";
import { CountryCodeOneToOneMap, countryDetails, DATASET_TYPE_MAPPING } from "@core/dictionary/global";
const UpSellModal = lazy(() => import("@components/layout/upSellModal"));

const DataSource = (props) => {
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const searchCardDetails = useSelector((state) => state?.shipmentDetails?.searchParameters);
  const dataSourceOptionDetails = creditDetails.dataSourceOptionDetails;
  const [continentList, setContinentList] = useState(CONTINENT_LIST);
  const [selectedDataSet, setSelectedDataSet] = useState([]);
  const [countries, setCountries] = useState(creditDetails?.dataSourceList || []);
  const [expandedRegions, setExpandedRegions] = useState({ NA: true, ASIA: true, CSA: true, AFRICA: true, LTM: true, EU: true, MIRROR: true });
  const [selectAll, setSelectAll] = useState({
    import: false,
    export: false,
  });
  const [inputValue, setInputValue] = useState("");
  const [upsellModal, setUpsellModal] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedDataSource = sessionStorage.getItem("selectedCountry");
  const currentUserPlan = LocalStorageService.getUserCurrentPlan();
  const intelHeaderDataSource = creditDetails?.header;
  const [filteredCountriesList, setFilterCountriesList] = useState(countries);
  const [filteredRegionList, setFilteredRegionList] = useState(CONTINENT_LIST);
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const toggleRegion = (region) => {
    setExpandedRegions((prev) => ({ ...prev, [region]: !prev[region] }));
  };
  const allNormalDatasets = Object.keys(countryDetails).filter((item) => item !== "trademo_MC" && !countryDetails[item]?.name?.toLowerCase()?.includes("mirror"));
  const subscribedProductIds = Object.assign(
    {},
    intelHeaderDataSource.filter((item) => item.product_id !== "trademo_MC")
  );
  const datasetSubsMapping = Object.values(subscribedProductIds).reduce((acc, item) => {
    acc[item.product_id] = item.is_subscribed;
    return acc;
  }, {});
  const areAllNormalSubscribed = allNormalDatasets.every((id) => datasetSubsMapping[id]);

  useEffect(() => {
    if (Object.keys(countries).length) {
      if (selectedDataSource !== "undefined" && !!selectedDataSource && JSON.parse(selectedDataSource)?.data?.length > 1 && window.location.href.includes("all-country-shipment")) {
        if (new URLSearchParams(window.location.search).get("viewType") || new URLSearchParams(window.location.search).get("searchType")) {
          multiCountryNoSessionExist();
        } else {
          multiCountrySessionExistHandler();
        }
      } else if (window.location.href.includes("all-country-shipment") && !JSON.parse(selectedDataSource)?.data?.length) {
        multiCountryNoSessionExist();
      } else if (props?.type !== "") {
        if (selectedDataSource && JSON.parse(selectedDataSource)?.data?.length > 1) {
          multiCountrySessionExistHandler();
        } else singleCountrySessionHandler();
      } else {
        if (window.location.href.includes("all-country-shipment")) {
          multiCountryNoSessionExist();
        } else {
          singleCountrySessionHandler();
        }
      }
    }
  }, [props.companyProfileDataSourceAccess]);

  useEffect(() => {
    if (countries && props.showHeaderDropdown === true) {
      let optionsClone = JSON.parse(JSON.stringify(countries));
      let appliedCountryList = [];
      Object.keys(optionsClone).forEach((option) => {
        Object.keys(optionsClone[option]).forEach((cntryData) => {
          if (props.comingFrom) {
            props?.companyProfileDataSourceAccess?.forEach((item2) => {
              if (item2?.isSubscribed && (optionsClone?.[option]?.[cntryData]?.countryName === item2?.country_name || optionsClone?.[option]?.[cntryData]?.countryCode === item2?.country_code) && cntryData?.toLowerCase() === item2?.source?.toLowerCase()) {
                optionsClone[option][cntryData]["isChecked"] = true;
                appliedCountryList.push(optionsClone[option][cntryData]);
              }
            });
          } else {
            if (optionsClone[option][cntryData]) {
              optionsClone[option][cntryData]["isChecked"] = true;
              appliedCountryList.push(optionsClone[option][cntryData]);
            }
          }
        });
      });
      setSelectedDataSet(appliedCountryList);
    }
  }, [props.showHeaderDropdown]);

  const handleSearch = (input) => {
    handleCheckboxes(input);
    setInputValue(input);
  };

  const handleCheckboxes = (search) => {
    const filtered = continentList?.filter((continent) => continent.label.toLowerCase().includes(search.toLowerCase()));

    const checkFilter = (country, continent) => {
      const isSubscribed = (type) => country[type]?.dataSourceInfo.is_subscribed === true;
      const matchesContinent = (type) => country[type]?.continent === continent.value;
      const matchesSearch = (type) => country[type]?.countryName.toLowerCase().includes(search.toLowerCase());
      const isFiltered = filtered.length === continentList.length ? (matchesSearch("import") || matchesSearch("export")) && (matchesContinent("import") || matchesContinent("export")) && (isSubscribed("import") || isSubscribed("export")) : (matchesContinent("import") || matchesContinent("export")) && (isSubscribed("import") || isSubscribed("export"));

      return isFiltered;
    };
    if (filtered.length > 0) {
      const countriesClone = {};
      filtered.map((continent) => {
        Object.keys(countries)
          .filter((item) => checkFilter(countries[item], continent))
          .map((country) => (countriesClone[country] = countries[country]));
      });
      let continentListClone = continentList?.map((continent) => ({
        ...continent,
        isChecked: {
          import: checkContinentSelected(countriesClone, continent.value, "import"),
          export: checkContinentSelected(countriesClone, continent.value, "export"),
        },
      }));
      setContinentList(continentListClone);
      let selectAllClone = structuredClone(selectAll);

      selectAllClone.import = filtered.every((item) => item.value !== "MIRROR" && item.isChecked.import === true);
      selectAllClone.export = filtered.every((item) => item.value !== "MIRROR" && item.isChecked.export === true);

      setSelectAll(selectAllClone);
      setFilteredRegionList(filtered);
      setFilterCountriesList(countriesClone);
    } else {
      let filterContinets = [];
      continentList?.map((continent) => {
        const filteredCountries = Object.keys(countries).filter((item) => checkFilter(countries[item], continent) && (countries[item]?.import?.countryName?.toLowerCase()?.includes(search) || countries[item]?.export?.countryName?.toLowerCase()?.includes(search)));
        if (filteredCountries.length > 0) filterContinets.push(continent);
      });
      const countriesClone = {};
      Object.keys(countries).filter((item) => {
        if (countries[item]?.import?.countryName?.toLowerCase()?.includes(search) || countries[item]?.export?.countryName?.toLowerCase()?.includes(search)) {
          countriesClone[item] = countries[item];
        }
      });
      let continentListClone = continentList.map((continent) => ({
        ...continent,
        isChecked: {
          import: checkContinentSelected(countriesClone, continent.value, "import"),
          export: checkContinentSelected(countriesClone, continent.value, "export"),
        },
      }));
      filterContinets = filterContinets.map((continent) => ({
        ...continent,
        isChecked: {
          import: checkContinentSelected(countriesClone, continent.value, "import"),
          export: checkContinentSelected(countriesClone, continent.value, "export"),
        },
      }));
      setContinentList(continentListClone);
      let selectAllClone = structuredClone(selectAll);
      selectAllClone.import = filterContinets.every((item) => item.isChecked.import === true);
      selectAllClone.export = filterContinets.every((item) => item.isChecked.export === true);
      setSelectAll(selectAllClone);
      setFilteredRegionList(filterContinets);
      setFilterCountriesList(countriesClone);
    }
  };

  const checkContinentSelected = (filteredData, continent, type) => {
    if (props.comingFrom) {
      const data = Object.values(filteredData).filter((country) => country[type]?.continent === continent && props?.companyProfileDataSourceAccess.find((source) => source.source.toLowerCase() === type && country[type].countryCode === source.country_code));
      return data.length > 0 && data.every((country) => country[type].isChecked === true);
    } else {
      const data = Object.values(filteredData).filter((country) => country[type]?.continent === continent);
      return data.length > 0 && data.every((country) => country[type].isChecked === true);
    }
  };

  const multiCountrySessionExistHandler = () => {
    let selectedCountryClone = JSON.parse(selectedDataSource)?.data;
    let optionsClone = JSON.parse(JSON.stringify(countries));
    let continentListClone = JSON.parse(JSON.stringify(continentList || []));
    let selectAllClone = JSON.parse(JSON.stringify(selectAll));
    let countryFlatArray = [];
    let appliedCountryList = [];
    const sessionHasDirect = selectedCountryClone.some((item) => item.continent !== "MIRROR");
    Object.keys(optionsClone).forEach((option) => {
      Object.keys(optionsClone[option]).forEach((cntryData) => {
        const isMirror = optionsClone[option][cntryData]?.continent === "MIRROR";
        if (sessionHasDirect && isMirror) {
          countryFlatArray.push(optionsClone[option][cntryData]);
          return;
        }
        selectedCountryClone.forEach((item) => {
          if (props.comingFrom) {
            if (optionsClone[option][cntryData].value === item.value && optionsClone[option][cntryData].countryType === item.countryType && optionsClone[option][cntryData].continent === item.continent && optionsClone[option][cntryData].countryCode === item.countryCode) {
              appliedCountryList.push(optionsClone[option][cntryData]);
              optionsClone[option][cntryData]["isChecked"] = true;
            }
          } else {
            if (optionsClone[option][cntryData].value === item.value && optionsClone[option][cntryData].countryType === item.countryType && optionsClone[option][cntryData].continent === item.continent && optionsClone[option][cntryData].countryCode === item.countryCode) {
              appliedCountryList.push(optionsClone[option][cntryData]);
              optionsClone[option][cntryData]["isChecked"] = true;
            }
          }
        });
        countryFlatArray.push(optionsClone[option][cntryData]);
      });
    });
    setSelectedDataSet(appliedCountryList);
    sessionStorage.setItem("selectedCountry", JSON.stringify({ data: appliedCountryList }));
    setCountries(optionsClone);
    continentListClone.forEach((continent) => {
      let isImportSelected = true;
      let isExportSelected = true;
      let selectedCountry = countryFlatArray.filter((country) => country.continent === continent.value);
      if (props.companyProfileDataSourceAccess && props.companyProfileDataSourceAccess.length) {
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "import" && selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
            for (let j = 0; j < props.companyProfileDataSourceAccess.length; j++) {
              if (props.companyProfileDataSourceAccess[j].isSubscribed && (props.companyProfileDataSourceAccess[j].country_name === selectedCountry[i]?.countryName || props.companyProfileDataSourceAccess[j].country_name.toLowerCase() === selectedCountry[i]?.countryCode.toLowerCase()) && props.companyProfileDataSourceAccess[j].source?.toLowerCase() === selectedCountry[i]?.countryType?.toLowerCase()) {
                isImportSelected = false;
                break;
              }
              if (isImportSelected === false) {
                break;
              }
            }
          }
        }
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "export" && selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
            for (let j = 0; j < props.companyProfileDataSourceAccess.length; j++) {
              if (props.companyProfileDataSourceAccess[j].isSubscribed && (props.companyProfileDataSourceAccess[j].country_name === selectedCountry[i]?.countryName || props.companyProfileDataSourceAccess[j].country_name.toLowerCase() === selectedCountry[i]?.countryCode.toLowerCase()) && props.companyProfileDataSourceAccess[j].source?.toLowerCase() === selectedCountry[i]?.countryType?.toLowerCase()) {
                isExportSelected = false;
                break;
              }
              if (isExportSelected === false) {
                break;
              }
            }
          }
        }
      } else if (selectedCountry.length) {
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "import") {
            if (selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
              isImportSelected = false;
              break;
            }
          }
        }
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "export") {
            if (selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
              isExportSelected = false;
              break;
            }
          }
        }
      } else {
        isImportSelected = false;
        isExportSelected = false;
      }
      if (isImportSelected) {
        continent.isChecked.import = true;
      }
      if (isExportSelected) {
        continent.isChecked.export = true;
      }
    });

    let isAllImportSelected = true;
    let isAllExportSelected = true;
    for (let i = 0; i < continentListClone.length; i++) {
      if (!continentListClone[i].isChecked.import) {
        isAllImportSelected = false;
        break;
      }
    }
    for (let i = 0; i < continentListClone.length; i++) {
      if (!continentListClone[i].isChecked.export) {
        isAllExportSelected = false;
        break;
      }
    }
    if (isAllImportSelected) {
      selectAllClone.import = true;
    }
    if (isAllExportSelected) {
      selectAllClone.export = true;
    }
    setContinentList(continentListClone);
    setSelectAll(selectAllClone);
    dispatch(appliedSelectAllHandler(selectAllClone));
  };

  const multiCountryNoSessionExist = () => {
    let optionsClone = JSON.parse(JSON.stringify(countries));
    let continentListClone = JSON.parse(JSON.stringify(continentList));
    let appliedCountryList = [];
    Object.keys(optionsClone).forEach((option) => {
      Object.keys(optionsClone[option]).forEach((cntryData) => {
        if (props.comingFrom) {
          props?.companyProfileDataSourceAccess?.forEach((item2) => {
            if (item2.isSubscribed && (optionsClone[option][cntryData].countryName === item2?.country_name || optionsClone[option][cntryData]?.countryCode?.toLowerCase() === item2?.country_name?.toLowerCase()) && cntryData?.toLowerCase() === item2?.source?.toLowerCase() && optionsClone[option][cntryData]?.continent !== "MIRROR") {
              optionsClone[option][cntryData]["isChecked"] = true;
              appliedCountryList.push(optionsClone[option][cntryData]);
            }
          });
        } else {
          if (optionsClone[option][cntryData] && optionsClone[option][cntryData]?.continent !== "MIRROR") {
            optionsClone[option][cntryData]["isChecked"] = true;
            appliedCountryList.push(optionsClone[option][cntryData]);
          }
        }
        if (optionsClone[option][cntryData]?.continent === "MIRROR") {
          optionsClone[option]["import"]["isChecked"] = false;
          optionsClone[option]["export"]["isChecked"] = false;
        }
      });
    });
    continentListClone.forEach((continent) => {
      if (props.comingFrom) {
        continent.isChecked.import = true;
        continent.isChecked.export = true;
      } else {
        continent.isChecked.import = true;
        continent.isChecked.export = true;
      }
    });
    setSelectedDataSet(appliedCountryList);
    sessionStorage.setItem("selectedCountry", JSON.stringify({ data: appliedCountryList }));
    dispatch(searchParametersHandler({ searchCategory: "", searchedItem: "", matchType: "", dataSource: `${"multi_country}"}`, redirectionId: "" }));
    setCountries(optionsClone);
    setContinentList(continentListClone);
    setSelectAll({ import: true, export: true });
    dispatch(appliedSelectAllHandler({ import: true, export: true }));
  };
  const singleCountrySessionHandler = () => {
    let optionsClone = JSON.parse(JSON.stringify(countries));
    let appliedCountryList = [];
    let continentListClone = JSON.parse(JSON.stringify(continentList));
    const [countryCode, countryType] = searchCardDetails?.dataSource?.toLowerCase()?.split("_") ?? ["", ""];
    const currentPathname = window.location.pathname;
    let countryFlatArray = [];
    Object.keys(optionsClone).forEach((option) => {
      Object.keys(optionsClone[option]).forEach((cntryData) => {
        if ((optionsClone[option][cntryData]?.url && currentPathname === optionsClone[option][cntryData]?.url) || (props.type && countryCode === optionsClone[option][cntryData]?.countryCode?.toLowerCase() && countryType.includes(optionsClone[option][cntryData]?.countryType?.toLowerCase()))) {
          appliedCountryList.push(optionsClone[option][cntryData]);
          optionsClone[option][cntryData]["isChecked"] = true;
        }
        countryFlatArray.push(optionsClone[option][cntryData]);
      });
    });
    setSelectedDataSet(appliedCountryList);
    sessionStorage.setItem("selectedCountry", JSON.stringify({ data: appliedCountryList }));
    continentListClone.forEach((continent) => {
      let isImportSelected = true;
      let isExportSelected = true;
      let selectedCountry = countryFlatArray.filter((country) => country.continent === continent.value);

      if (props.companyProfileDataSourceAccess && props.companyProfileDataSourceAccess.length) {
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "import" && selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
            for (let j = 0; j < props.companyProfileDataSourceAccess.length; j++) {
              if (props.companyProfileDataSourceAccess[j].isSubscribed && (props.companyProfileDataSourceAccess[j].country_name === selectedCountry[i]?.countryName || props.companyProfileDataSourceAccess[j].country_name.toLowerCase() === selectedCountry[i]?.countryCode.toLowerCase()) && props.companyProfileDataSourceAccess[j].source?.toLowerCase() === selectedCountry[i]?.countryType?.toLowerCase()) {
                isImportSelected = false;
                break;
              }
              if (isImportSelected === false) {
                break;
              }
            }
          }
        }
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "export" && selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
            for (let j = 0; j < props.companyProfileDataSourceAccess.length; j++) {
              if (props.companyProfileDataSourceAccess[j].isSubscribed && (props.companyProfileDataSourceAccess[j].country_name === selectedCountry[i]?.countryName || props.companyProfileDataSourceAccess[j].country_name.toLowerCase() === selectedCountry[i]?.countryCode.toLowerCase()) && props.companyProfileDataSourceAccess[j].source?.toLowerCase() === selectedCountry[i]?.countryType?.toLowerCase()) {
                isExportSelected = false;
                break;
              }
              if (isExportSelected === false) {
                break;
              }
            }
          }
        }
      } else if (selectedCountry.length) {
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "import") {
            if (selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
              isImportSelected = false;
              break;
            }
          }
        }
        for (let i = 0; i < selectedCountry.length; i++) {
          if (!selectedCountry[i].isChecked && selectedCountry[i].countryType?.toLowerCase() === "export") {
            if (selectedCountry[i]?.dataSourceInfo?.is_subscribed) {
              isExportSelected = false;
              break;
            }
          }
        }
      } else {
        isImportSelected = false;
        isExportSelected = false;
      }
      if (isImportSelected) {
        continent.isChecked.import = true;
      }
      if (isExportSelected) {
        continent.isChecked.export = true;
      }
    });
    setCountries(optionsClone);
    setContinentList(continentListClone);
  };
  const checkOptionsHandler = (checked, type, country, continent) => {
    let optionsClone = { ...countries };
    if (continent.value === "MIRROR") {
      const newOptions = { ...countries };
      Object.keys(newOptions).forEach((key) => {
        const item = newOptions[key];
        // Only uncheck direct (non-MIRROR) datasets; other mirror selections stay so multiple mirrors can be selected together.
        if (item["import"]?.continent !== "MIRROR" && item["import"]?.isChecked) item["import"].isChecked = false;
        if (item["export"]?.continent !== "MIRROR" && item["export"]?.isChecked) item["export"].isChecked = false;
      });
    } else {
      Object.keys(optionsClone).forEach((key) => {
        const item = optionsClone[key];
        if (item["import"]?.continent === "MIRROR" || item["export"]?.continent === "MIRROR") {
          if (item["import"]?.isChecked) item["import"].isChecked = false;
          if (item["export"]?.isChecked) item["export"].isChecked = false;
        }
      });
    }

    let continentListClone = [...continentList];
    let selectAllClone = { ...selectAll };
    optionsClone[country][type].isChecked = checked;
    setCountries(optionsClone);
    const relevantCountries = Object.values(optionsClone).filter((c) => c[type]?.continent === continent.value);
    const isAllChecked = relevantCountries.every((c) => c[type].isChecked || !c[type].dataSourceInfo.is_subscribed);
    if (checked) {
      if (props.comingFrom) {
        props.companyProfileDataSourceAccess.forEach((item) => {
          if ((optionsClone[country][type].countryName === item.country_name || optionsClone[country][type].countryCode.toLowerCase() === item.country_code.toLowerCase()) && type === item.source && continent.value === optionsClone[country][type].continent && item.isSubscribed) {
            optionsClone[country][type].isChecked = checked;
          }
        });
      }
      if (isAllChecked) {
        continentListClone = continentListClone.map((c) => (c.value === continent.value ? { ...c, isChecked: { ...c.isChecked, [type]: true } } : c));

        if (continentListClone.every((c) => c.isChecked[type])) {
          selectAllClone[type] = true;
          setSelectAll(selectAllClone);
        }
      }
    } else {
      continentListClone = continentListClone.map((c) => (c.value === continent.value ? { ...c, isChecked: { ...c.isChecked, [type]: false } } : c));
      selectAllClone[type] = false;
      setSelectAll(selectAllClone);
    }
    setContinentList(continentListClone);
    const appliedCountryList = [];
    Object.keys(optionsClone).map((option) => {
      Object.keys(optionsClone[option]).map((cntryData) => {
        if (optionsClone[option][cntryData] && optionsClone[option][cntryData]["isChecked"]) {
          appliedCountryList.push(optionsClone[option][cntryData]);
        }
      });
    });
    setSelectedDataSet(appliedCountryList);
    handleCheckboxes(inputValue);
  };

  const checkBothOptionsHandler = (checked, country, continent) => {
    const optionsClone = { ...countries };
    let continentListClone = [...continentList];
    let selectAllClone = { ...selectAll };
    const types = ["import", "export"];

    if (checked) {
      if (props.comingFrom) {
        props.companyProfileDataSourceAccess.forEach((item) => {
          types.forEach((type) => {
            if (optionsClone[country][type] && (optionsClone[country][type].countryName === item.country_name || optionsClone[country][type].countryCode.toLowerCase() === item.country_code.toLowerCase()) && (type === item.source || item.source === "both") && continent.value === optionsClone[country][type].continent && item.isSubscribed) {
              optionsClone[country][type].isChecked = checked;
            }
          });
        });
      } else {
        types.forEach((type) => {
          if (optionsClone[country][type]) {
            optionsClone[country][type].isChecked = checked;
          }
        });
      }
      const relevantCountries = Object.values(optionsClone).filter((c) => c.import?.continent === continent.value || c.export?.continent === continent.value);

      const isAllCheckedByType = types.reduce((acc, type) => {
        acc[type] = relevantCountries.every((country) => country[type]?.isChecked || !country[type]?.dataSourceInfo.is_subscribed);
        return acc;
      }, {});
      continentListClone = continentListClone.map((c) =>
        c.value === continent.value
          ? {
              ...c,
              isChecked: {
                import: isAllCheckedByType.import,
                export: isAllCheckedByType.export,
              },
            }
          : c
      );

      selectAllClone = {
        import: continentListClone.every((c) => c.isChecked.import),
        export: continentListClone.every((c) => c.isChecked.export),
      };
    } else {
      continentListClone = continentListClone.map((c) => (c.value === continent.value ? { ...c, isChecked: { import: false, export: false } } : c));
      if (props.comingFrom) {
        props.companyProfileDataSourceAccess.forEach((item) => {
          types.forEach((type) => {
            if (optionsClone[country][type] && (optionsClone[country][type].countryName === item.country_name || optionsClone[country][type].countryCode.toLowerCase() === item.country_code.toLowerCase()) && (type === item.source || item.source === "both") && continent.value === optionsClone[country][type].continent && item.isSubscribed) {
              optionsClone[country][type].isChecked = checked;
            }
          });
        });
      } else {
        types.forEach((type) => {
          if (optionsClone[country][type]) {
            optionsClone[country][type].isChecked = checked;
          }
        });
      }
      selectAllClone = {
        import: selectAllClone.import,
        export: selectAllClone.export,
      };
    }
    setCountries(optionsClone);
    setSelectAll(selectAllClone);
    setContinentList(continentListClone);

    const appliedCountryList = [];
    Object.keys(optionsClone).map((option) => {
      Object.keys(optionsClone[option]).map((cntryData) => {
        if (optionsClone[option][cntryData] && optionsClone[option][cntryData]["isChecked"]) {
          appliedCountryList.push(optionsClone[option][cntryData]);
        }
      });
    });
    setSelectedDataSet(appliedCountryList);
    handleCheckboxes(inputValue);
  };

  const selectAllHandler = (checked, type) => {
    let selectAllClone = JSON.parse(JSON.stringify(selectAll));
    let optionsClone = JSON.parse(JSON.stringify(countries));
    selectAllClone[type] = checked;
    setSelectAll(selectAllClone);
    let continentListClone = continentList.map((item) => ({ ...item, isChecked: { ...item.isChecked, [type]: filteredRegionList.find((continent) => continent.value === item.value) ? checked : false } }));
    setContinentList(continentListClone);
    let appliedCountryList = [];
    Object.keys(optionsClone).forEach((country) => {
      if (props.comingFrom) {
        props?.companyProfileDataSourceAccess?.forEach((item2) => {
          if (optionsClone[country][type] && (optionsClone[country][type].countryName === item2?.country_name || optionsClone[country][type].countryCode.toLowerCase() === item2?.country_code.toLowerCase()) && type?.toLowerCase() === item2?.source?.toLowerCase() && optionsClone[country][type] && item2.isSubscribed && (filteredCountriesList?.[country]?.[type] ?? false)) {
            optionsClone[country][type]["isChecked"] = checked;
          }
        });
      } else {
        if (optionsClone[country][type] && (filteredCountriesList?.[country]?.[type] ?? false) && optionsClone[country][type].continent !== "MIRROR") {
          optionsClone[country][type]["isChecked"] = checked;
        }
      }
      if (optionsClone[country][type]?.continent === "MIRROR") {
        optionsClone[country]["export"]["isChecked"] = false;
        optionsClone[country]["import"]["isChecked"] = false;
      }
    });
    Object.keys(optionsClone).map((option) => {
      Object.keys(optionsClone[option]).map((cntryData) => {
        if (optionsClone[option][cntryData] && optionsClone[option][cntryData]["isChecked"]) {
          appliedCountryList.push(optionsClone[option][cntryData]);
        }
      });
    });
    setSelectedDataSet(appliedCountryList);
    setCountries(optionsClone);
  };
  const superSelectAllHandler = (checked) => {
    const selectAllClone = { import: checked, export: checked };
    const optionsClone = { ...countries };

    setSelectAll(selectAllClone);

    const continentListClone = continentList.map((item) => ({
      ...item,
      isChecked: { import: filteredRegionList.find((continent) => continent.value === item.value) ? checked : false, export: filteredRegionList.find((continent) => continent.value === item.value) ? checked : false },
    }));
    setContinentList(continentListClone);

    const appliedCountryList = [];
    Object.keys(optionsClone).forEach((country) => {
      ["import", "export"].forEach((type) => {
        if (optionsClone[country][type]) {
          if (props.comingFrom) {
            const matchingItem = props.companyProfileDataSourceAccess?.find((item) => (optionsClone[country][type].countryName === item?.country_name || optionsClone[country][type].countryCode.toLowerCase() === item?.country_code?.toLowerCase()) && (type.toLowerCase() === item?.source?.toLowerCase() || item?.source?.toLowerCase() === "both") && item.isSubscribed);
            if (matchingItem && (filteredCountriesList?.[country]?.[type] ?? false)) {
              optionsClone[country][type].isChecked = checked;
            }
          } else if (filteredCountriesList?.[country]?.[type] ?? false) {
            optionsClone[country][type].isChecked = checked;
          }
          if (optionsClone[country][type]?.continent === "MIRROR") {
            optionsClone[country][type].isChecked = false;
          }
          if (optionsClone[country][type].isChecked) {
            appliedCountryList.push(optionsClone[country][type]);
          }
        }
      });
    });

    setSelectedDataSet(appliedCountryList);
    setCountries(optionsClone);
  };

  const checkIfContinentDisable = (e, v) => {
    if (v === "MIRROR") return true;
    let flag = false;
    if (!props || props?.companyProfileDataSourceAccess?.length === 0) {
      return false;
    }
    for (let i = 0; i < Object.keys(filteredCountriesList)?.length; i++) {
      let tempFlag = true;
      for (let j = 0; j < props?.companyProfileDataSourceAccess?.length; j++) {
        if (e.toLowerCase() === props?.companyProfileDataSourceAccess[j]?.source?.toLowerCase() && filteredCountriesList[Object.keys(filteredCountriesList)[i]][e]?.dataSourceInfo?.is_subscribed === true && props?.companyProfileDataSourceAccess[j]?.country_code?.toLowerCase() === filteredCountriesList[Object.keys(filteredCountriesList)[i]][e]?.countryCode?.toLowerCase() && v === filteredCountriesList[Object.keys(filteredCountriesList)[i]][e]?.continent) {
          tempFlag = false;
          break;
        }
      }
      if (!tempFlag) {
        flag = false;
        break;
      }
      flag = tempFlag;
    }
    return flag;
  };

  const selectContinentHandler = (checked, type, continent) => {
    let selectAllClone = JSON.parse(JSON.stringify(selectAll));
    let optionsClone = JSON.parse(JSON.stringify(countries));
    let appliedCountryList = [];
    if (!checked) {
      selectAllClone[type] = checked;
      let continentListClone = continentList.map((item) => {
        if (continent.value === item.value) {
          return { ...item, isChecked: { ...item.isChecked, [type]: checked } };
        } else {
          return item;
        }
      });
      Object.keys(optionsClone).forEach((country) => {
        if (optionsClone[country][type] && continent.value === optionsClone[country][type].continent && (filteredCountriesList?.[country]?.[type] ?? false)) {
          optionsClone[country][type]["isChecked"] = checked;
        }
        if (optionsClone[country][type]?.continent === "MIRROR") {
          optionsClone[country]["import"]["isChecked"] = false;
          optionsClone[country]["export"]["isChecked"] = false;
        }
      });
      Object.keys(optionsClone).map((option) => {
        Object.keys(optionsClone[option]).map((cntryData) => {
          if (optionsClone[option][cntryData] && optionsClone[option][cntryData]["isChecked"]) {
            appliedCountryList.push(optionsClone[option][cntryData]);
          }
        });
      });
      setSelectedDataSet(appliedCountryList);
      setSelectAll(selectAllClone);
      setContinentList(continentListClone);
      setCountries(optionsClone);
    } else {
      let selectAllClone = JSON.parse(JSON.stringify(selectAll));
      let optionsClone = JSON.parse(JSON.stringify(countries));
      let isAllChecked = true;
      let continentListClone = continentList.map((item) => {
        if (continent.value === item.value) {
          return { ...item, isChecked: { ...item.isChecked, [type]: checked } };
        } else {
          return item;
        }
      });
      let filteredContinentListClone = filteredRegionList.map((item) => {
        if (continent.value === item.value) {
          return { ...item, isChecked: { ...item.isChecked, [type]: checked } };
        } else {
          return item;
        }
      });
      Object.keys(optionsClone).forEach((country) => {
        if (props.comingFrom) {
          props.companyProfileDataSourceAccess.forEach((item2) => {
            if (optionsClone[country][type] && (optionsClone[country][type].countryName === item2?.country_name || optionsClone[country][type].countryCode.toLowerCase() === item2?.country_code.toLowerCase()) && type?.toLowerCase() === item2?.source?.toLowerCase() && optionsClone[country][type] && continent.value === optionsClone[country][type].continent && item2.isSubscribed && (filteredCountriesList?.[country]?.[type] ?? false)) {
              optionsClone[country][type]["isChecked"] = checked;
            }
          });
        } else {
          if (optionsClone[country][type] && continent.value === optionsClone[country][type].continent && (filteredCountriesList?.[country]?.[type] ?? false)) {
            optionsClone[country][type]["isChecked"] = checked;
          }
        }
        if (optionsClone[country][type]?.continent === "MIRROR") {
          optionsClone[country]["import"]["isChecked"] = false;
          optionsClone[country]["export"]["isChecked"] = false;
        }
      });
      for (let i = 0; i < filteredContinentListClone.length; i++) {
        if (!filteredContinentListClone[i]["isChecked"][type]) {
          isAllChecked = false;
          break;
        }
      }
      if (isAllChecked) {
        selectAllClone[type] = true;
        setSelectAll(selectAllClone);
      }
      Object.keys(optionsClone).map((option) => {
        Object.keys(optionsClone[option]).map((cntryData) => {
          if (optionsClone[option][cntryData] && optionsClone[option][cntryData]["isChecked"]) {
            appliedCountryList.push(optionsClone[option][cntryData]);
          }
        });
      });
      setSelectedDataSet(appliedCountryList);
      setContinentList(continentListClone);
      setCountries(optionsClone);
    }
  };

  const onCancelHandler = () => {
    let typeImport = "import";
    let typeExport = "export";
    let selectAllClone = JSON.parse(JSON.stringify(selectAll));
    let optionsClone = JSON.parse(JSON.stringify(countries));
    selectAllClone[typeImport] = false;
    selectAllClone[typeExport] = false;
    setSelectAll(selectAllClone);
    let continentListClone = continentList.map((item) => ({ ...item, isChecked: { ...item.isChecked, [typeImport]: false, [typeExport]: false } }));
    setContinentList(continentListClone);
    let appliedCountryList = [];
    Object.keys(optionsClone).forEach((country) => {
      if (props.comingFrom) {
        props.companyProfileDataSourceAccess.forEach((item2) => {
          if (optionsClone[country][typeImport] && (optionsClone[country][typeImport].countryName === item2?.country_name || optionsClone[country][typeImport].countryCode.toLowerCase() === item2?.country_code.toLowerCase()) && typeImport?.toLowerCase() === item2?.source?.toLowerCase() && optionsClone[country][typeImport] && item2.isSubscribed) {
            optionsClone[country][typeImport]["isChecked"] = false;
          }
          if (optionsClone[country][typeExport] && (optionsClone[country][typeExport].countryName === item2?.country_name || optionsClone[country][typeExport].countryCode.toLowerCase() === item2?.country_code.toLowerCase()) && typeExport?.toLowerCase() === item2?.source?.toLowerCase() && optionsClone[country][typeExport] && item2.isSubscribed) {
            optionsClone[country][typeExport]["isChecked"] = false;
          }
        });
      } else {
        if (optionsClone[country][typeImport]) {
          optionsClone[country][typeImport]["isChecked"] = false;
        }
        if (optionsClone[country][typeExport]) {
          optionsClone[country][typeExport]["isChecked"] = false;
        }
      }
    });
    setSelectedDataSet(appliedCountryList);
    setCountries(optionsClone);
  };
  const onApplyHandler = () => {
    let appliedCountryList = [];
    const subscribedDataSets = [];
    Object.keys(countries).map((option) => {
      Object.keys(countries[option]).map((cntryData) => {
        if (countries[option][cntryData] && countries[option][cntryData]["isChecked"] && countries[option][cntryData].dataSourceInfo.is_subscribed === true) {
          appliedCountryList.push(countries[option][cntryData]);
        }
        if (countries[option][cntryData].dataSourceInfo.is_subscribed === true) {
          subscribedDataSets.push(countries[option][cntryData]);
        }
      });
    });
    dispatch(appliedSelectAllHandler(selectAll));
    if (appliedCountryList.length === 1) {
      let url = appliedCountryList[0]?.url;
      setSelectedDataSet(appliedCountryList);
      dispatch(searchParametersHandler({ searchCategory: "", searchedItem: "", matchType: "", dataSource: `${selectedDataSet?.[0]?.countryCode?.toLowerCase()}_${selectedDataSet?.[0]?.countryType}`, redirectionId: "" }));
      sessionStorage.setItem("selectedCountry", JSON.stringify({ data: appliedCountryList }));
      if (props?.type !== "") {
        history.push(url);
      } else {
        history.push(url + window.location.search.replace("&viewType=aggregate", "").replace("isReload=true", ""));
      }
    } else if (appliedCountryList.length > 1) {
      setSelectedDataSet(appliedCountryList);
      sessionStorage.setItem("selectedCountry", JSON.stringify({ data: appliedCountryList }));
      if (window.location.href.includes("all-country-shipment")) {
        history.push("all-country-shipments" + window.location.search.replace("&viewType=aggregate", ""));
        props?.updateMultiCountryDataSourceHandler();
      } else {
        dispatch(searchParametersHandler({ searchCategory: "", searchedItem: "", matchType: "", dataSource: `${"multi_country}"}`, redirectionId: "" }));

        if (props?.type !== "") {
          history.push("/all-country-shipments");
          return false;
        } else {
          history.push("/all-country-shipments" + window.location.search.replace("&viewType=aggregate", "").replace("isReload=true", ""));
        }
      }
    }
    props?.closeHeaderDropDown();
  };
  const dataSourceInfo = (productId) => {
    let dataSourceInfo = {};
    if (!!intelHeaderDataSource && !!intelHeaderDataSource?.length) {
      for (let i = 0; i < intelHeaderDataSource.length; i++) {
        if (!!productId && !!intelHeaderDataSource && intelHeaderDataSource[i].product_id.toLowerCase() === productId.toLowerCase()) {
          dataSourceInfo = {
            is_subscribed: intelHeaderDataSource[i].is_subscribed ? intelHeaderDataSource[i].is_subscribed : false,
            exports_count: intelHeaderDataSource[i].exports_count ? intelHeaderDataSource[i].exports_count : null,
            imports_count: intelHeaderDataSource[i].imports_count || null,
            total_count: !!intelHeaderDataSource[i].exports_count && !!intelHeaderDataSource[i].imports_count ? intelHeaderDataSource[i].exports_count + intelHeaderDataSource[i].imports_count : !!intelHeaderDataSource[i].exports_count && !intelHeaderDataSource[i].imports_count ? intelHeaderDataSource[i].exports_count : !!intelHeaderDataSource[i].imports_count && !intelHeaderDataSource[i].exports_count ? intelHeaderDataSource[i].imports_count : null,
          };
        }
      }
    }
    return dataSourceInfo;
  };

  const handleSubmit = () => {
    trademoTrackingEvents(trackingEventDictionary.datasetDropdownUpsellGetInTouch, generateTrackingObject(dataSource ? dataSource : window.location.pathname, pathname, getUserActivePlan()));
    setUpsellModal(true);
  };

  const checkIfSelectAllDisable = (type) => {
    let flag = false;
    for (let i = 0; i < continentList?.length; i++) {
      flag = checkIfContinentDisable(type, continentList[i].value);
      if (flag === false) {
        break;
      }
    }
    return flag;
  };

  const filteredContinentList = useMemo(() => {
    const filtered = continentList?.filter((continent) => continent.label.toLowerCase().includes(inputValue.toLowerCase()));
    return filtered.length > 0 ? filtered : continentList;
  }, [continentList, inputValue]);

  const isCountryFiltered = useCallback(
    (country, continent) => {
      const isSubscribed = (type) => country[type]?.dataSourceInfo.is_subscribed === true;
      const matchesContinent = (type) => country[type]?.continent === continent.value;
      const matchesSearch = (type) => country[type]?.countryName.toLowerCase().includes(inputValue.toLowerCase());

      const isFiltered = filteredContinentList.length === continentList.length ? (matchesSearch("import") || matchesSearch("export")) && (matchesContinent("import") || matchesContinent("export")) && (isSubscribed("import") || isSubscribed("export")) : (matchesContinent("import") || matchesContinent("export")) && (isSubscribed("import") || isSubscribed("export"));

      return isFiltered;
    },
    [filteredContinentList, continentList, inputValue]
  );

  const renderCountryItem = useCallback(
    (value, continent) => {
      const country = countries[value];
      return (
        <div className="tw-flex tw-items-center tw-w-full" key={value}>
          <div className="tw-w-9 tw-h-9 tw-py-2 tw-px-3 tw-invisible">child</div>
          <div className="tw-py-2 tw-pl-6 tw-flex tw-items-center tw-gap-2 tw-relative tw-w-3/5">
            {/* <input type="checkbox" onChange={(e) => checkBothOptionsHandler(e.target.checked, value, continent)} disabled={isDisabled} checked={country?.import?.isChecked && (country?.export?.isChecked ?? true)} className="after:!tw-top-2.5 after:!tw-left-6 after:!tw-w-4 after:!tw-h-4 after:!tw-border after:!tw-rounded" /> */}
            <div className="tw-text-sm tw-font-normal tw-gray-900 tw-flex tw-items-center tw-gap-2">
              {value === "middleeast" ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg" width={"14px"} height={"14px"} /> : CountryCodeOneToOneMap[value] ? <ReactCountryFlag countryCode={CountryCodeOneToOneMap[value]} svg /> : <ReactCountryFlag countryCode={value} svg />}
              {isoCountries[value?.toUpperCase()]}
              {DATASET_TYPE_MAPPING[`${value}_import`]}
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-w-2/3">
            {["import", "export"].map(
              (type) =>
                country[type] && (
                  <div key={type} className="tw-py-2 tw-px-3 tw-flex tw-items-center tw-justify-end tw-gap-2 tw-relative">
                    <input type="checkbox" onChange={(e) => checkOptionsHandler(e.target.checked, type, value, continent)} disabled={props?.comingFrom && (!props?.companyProfileDataSourceAccess || !props?.companyProfileDataSourceAccess.some((item) => item.source?.toLowerCase() === type && item.country_code.toLowerCase() === value && item.isSubscribed))} checked={country[type]?.isChecked} className="after:!tw-top-2.5 after:!tw-left-3 after:!tw-w-4 after:!tw-h-4 after:!tw-border after:!tw-rounded" />
                    <div className="tw-text-sm tw-font-medium tw-gray-900 tw-invisible">All {type.charAt(0).toUpperCase() + type.slice(1)}s</div>
                  </div>
                )
            )}
          </div>
        </div>
      );
    },
    [countries, checkBothOptionsHandler, checkOptionsHandler, props?.comingFrom, props?.companyProfileDataSourceAccess, isoCountries]
  );

  // Parent checkboxes (All Countries / All Imports / All Exports) are direct-only controls, so
  // only show them when a real direct (non-MIRROR) subscribed dataset is present. A mirror-only
  // account (e.g. India Mirror) should not see them.
  const showParentCheckboxes = () => filteredContinentList?.some((continent) => continent.value !== "MIRROR" && Object.keys(countries).some((item) => isCountryFiltered(countries[item], continent)));
  // Whether any subscribed dataset (direct OR mirror) matches the current filter. Drives the
  // "No countries found" empty state so it does not show for a mirror-only account.
  const hasAnyFilteredCountry = () => filteredContinentList?.some((continent) => Object.keys(countries).some((item) => isCountryFiltered(countries[item], continent)));

  return (
    <div className="tw-absolute tw-top-[85px] tw-z-10 tw-flex tw-items-center">
      <div className="tw-bg-white tw-rounded-xl tw-w-[550px] tw-max-h-[500px] tw-overflow-y-auto tw-shadow-autoSuggest">
        <div className="tw-flex tw-justify-between tw-items-center tw-p-3 tw-border-b tw-sticky tw-top-0 tw-bg-white tw-z-20">
          <div className="tw-flex tw-items-center tw-gap-1 tw-py-1.5 tw-px-3 tw-rounded-lg tw-border tw-border-gray-300 tw-h-7 tw-max-w-[300px] tw-w-full tw-bg-white">
            <svg fill="#101828" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
              <path d="M796-121 533-384q-30 26-69.959 40.5T378-329q-108.162 0-183.081-75Q120-479 120-585t75-181q75-75 181.5-75t181 75Q632-691 632-584.85 632-542 618-502q-14 40-42 75l264 262-44 44ZM377-389q81.25 0 138.125-57.5T572-585q0-81-56.875-138.5T377-781q-82.083 0-139.542 57.5Q180-666 180-585t57.458 138.5Q294.917-389 377-389Z" />
            </svg>
            <input className="tw-bg-transparent tw-text-sm" placeholder="Search country" value={inputValue} onChange={(e) => handleSearch(e.target.value)} />
          </div>
          {/* <div>
            <span className="tw-text-base tw-font-medium tw-text-gray-900">Data Sources</span>
          </div> */}
          <div className="tw-flex tw-gap-2">
            <Button variant="secondaryWithIcon" size="small" onClick={onCancelHandler} disabled={!selectedDataSet?.length}>
              <span>Clear All</span>
            </Button>
            <Button variant="primaryWithIcon" size="small" onClick={onApplyHandler} disabled={!selectedDataSet?.length}>
              <span>Apply</span>
            </Button>
          </div>
        </div>
        {showParentCheckboxes() ? (
          <div className="tw-flex tw-items-center tw-border-b tw-w-full tw-sticky tw-top-14 tw-bg-white tw-z-20">
            <div className="tw-w-9 tw-h-9 tw-py-2 tw-px-3 tw-invisible">checkbox</div>
            <div className="tw-py-2 tw-px-3 tw-flex tw-items-center tw-gap-2 tw-relative tw-w-3/5">
              <input type="checkbox" className="after:!tw-top-2.5 after:!tw-left-3 after:!tw-w-4 after:!tw-h-4 after:!tw-border after:!tw-rounded" checked={selectAll?.import && selectAll?.export} onChange={(e) => superSelectAllHandler(e.target.checked)} disabled={checkIfSelectAllDisable("import") || checkIfSelectAllDisable("export")} />
              <div className="tw-text-sm tw-font-medium tw-gray-900">All Countries</div>
            </div>
            <div className="tw-flex tw-items-center tw-w-2/3">
              {["import", "export"].map((type) => (
                <div key={type} className="tw-py-2 tw-px-3 tw-flex tw-items-center tw-justify-end tw-gap-2 tw-relative">
                  <input type="checkbox" className="after:!tw-top-2.5 after:!tw-left-3 after:!tw-w-4 after:!tw-h-4 after:!tw-border after:!tw-rounded" checked={selectAll?.[type]} onChange={(e) => selectAllHandler(e.target.checked, type)} disabled={checkIfSelectAllDisable(type)} />
                  <div className="tw-text-sm tw-font-medium tw-gray-900">All {type.charAt(0).toUpperCase() + type.slice(1)}s</div>
                </div>
              ))}
            </div>
          </div>
        ) : !hasAnyFilteredCountry() ? (
          <div className="tw-p-3 tw-text-sm tw-font-medium tw-gray-900">No countries found</div>
        ) : (
          <></>
        )}
        {filteredContinentList?.map((continent) => {
          const filteredCountries = Object.keys(countries).filter((item) => isCountryFiltered(countries[item], continent));
          if (filteredCountries.length === 0) return null;
          return (
            <div className="tw-border-b" key={continent?.label}>
              <div className="tw-flex tw-items-center tw-w-full">
                <div className="tw-w-9 tw-h-9 tw-py-2 tw-px-3 tw-cursor-pointer" onClick={() => toggleRegion(continent?.value)}>
                  {expandedRegions[continent?.value] ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </div>
                <div className={`tw-py-2 tw-px-3 tw-flex tw-items-center tw-gap-2 tw-relative ${continent.value === "MIRROR" ? "tw-w-[40%]" : "tw-w-3/5"}`}>
                  {/* <input type="checkbox" className="after:!tw-top-2.5 after:!tw-left-3 after:!tw-w-4 after:!tw-h-4 after:!tw-border after:!tw-rounded" checked={!checkIfContinentDisable("import", continent?.value) && !checkIfContinentDisable("export", continent?.value) && continent.isChecked.import && continent.isChecked.export} onChange={(e) => selectFullContinentHandler(e.target.checked, continent)} disabled={checkIfContinentDisable("import", continent?.value) || checkIfContinentDisable("export", continent?.value)} /> */}
                  <div className="tw-text-sm tw-font-semibold tw-gray-900">{continent?.label}</div>
                </div>
                <div className="tw-flex tw-items-center tw-w-2/3">
                  {continent?.value !== "MIRROR" ? (
                    ["import", "export"].map((type) => (
                      <div key={type} className="tw-py-2 tw-px-3 tw-flex tw-items-center tw-justify-end tw-gap-2 tw-relative">
                        {continent?.value !== "MIRROR" && <input type="checkbox" className="after:!tw-top-2.5 after:!tw-left-3 after:!tw-w-4 after:!tw-h-4 after:!tw-border after:!tw-rounded" checked={!checkIfContinentDisable(type, continent?.value) && continent.isChecked[type]} onChange={(e) => selectContinentHandler(e.target.checked, type, continent)} disabled={checkIfContinentDisable(type, continent?.value)} />}
                        <div className="tw-text-sm tw-font-medium tw-gray-900 tw-invisible">All {type.charAt(0).toUpperCase() + type.slice(1)}s</div>
                      </div>
                    ))
                  ) : (
                    <></>
                  )}
                  {continent?.value === "MIRROR" && expandedRegions[continent?.value] && <span className="tw-text-xs tw-font-medium">{"Mirror datasets cannot be combined with direct datasets."}</span>}
                </div>
              </div>
              {expandedRegions[continent?.value] && continent?.value === "MIRROR" ? (
                <div className="tw-flex tw-items-center tw-w-full tw-text-xs tw-font-normal tw-px-8">
                  <span className="tw-bg-demo_touch_point tw-border-none tw-rounded-lg tw-py-2 tw-px-4">Mirror Data shows a country's trade activity using information reported by its trading partners. For example, if Canada doesn’t report its trade data, we can assimilate all the trade with Canada from all the countries which do report trade to form Mirror Data.</span>
                </div>
              ) : (
                <></>
              )}
              {expandedRegions[continent?.value] && filteredCountries.sort((a, b) => a.localeCompare(b)).map((value) => renderCountryItem(value, continent))}
            </div>
          );
        })}
        {!areAllNormalSubscribed && (
          <section className="tw-flex tw-flex-col">
            {(dataSourceOptionDetails?.length > 0 && dataSourceOptionDetails?.filter((obj) => obj.dataSourceInfo.is_subscribed === false) !== undefined && dataSourceOptionDetails.filter((obj) => obj.dataSourceInfo.is_subscribed === false).length !== 0) || (!props.isMultiEnabled && !!dataSourceInfo("trademo_MC") && !dataSourceInfo("trademo_MC").is_subscribed && dataSourceInfo("trademo_MC").is_subscribed === false) ? (
              <article className="tw-flex tw-justify-between tw-gap-2 tw-text-sm tw-p-3">
                <div className="tw-flex tw-gap-1">
                  <img alt="img" src="https://res.cloudinary.com/drzta9shk/image/upload/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg" />
                  <div className="tw-flex tw-flex-col">
                    <strong>You are missing on trade data intelligence for the following countries.</strong>
                    <span>Connect with your account manager to get access.</span>
                  </div>
                </div>
                <div className="tw-w-max">
                  <Button variant={"primaryWithIcon"} size={"medium"} onClick={handleSubmit}>
                    <span className="tw-font-medium tw-text-nowrap tw-text-sm">Get in touch</span>
                  </Button>
                </div>
              </article>
            ) : (
              <></>
            )}
            <div className="tw-flex tw-flex-wrap">
              {Object.keys(countries)
                .filter((item) => (countries[item].import && countries[item].import.dataSourceInfo.is_subscribed === false) || (countries[item].export && countries[item].export.dataSourceInfo.is_subscribed === false))
                .sort((a, b) => (a > b ? 1 : -1))
                .map((value) => {
                  return (
                    <div className="tw-flex tw-items-center tw-w-1/2 tw-py-2 tw-px-3" key={value}>
                      <span className="tw-text-sm tw-text-gray-900 tw-flex tw-items-center">
                        <div className="">{countries[value].import.countryCode === "middleeast" ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg" className="tw-h-4 tw-w-4 mr-2" /> : <ReactCountryFlag className="trademo-search-flag data-source-country-flag mr-2 w-100" countryCode={countries[value] && countries[value].import ? countries[value].import?.countryCode?.slice(0, 2) : null} svg />}</div>
                        <div className="d-flex flex-column gap-2">
                          <span>
                            {isoCountries[`${value.toUpperCase()}`] + (DATASET_TYPE_MAPPING[`${value.toLowerCase()}_import`] ?? (globalCountryDetailsDictionary[`${value.toLowerCase()}_import`]?.continent === "MIRROR" ? " (Mirror)" : ""))}
                            <span className="tw-text-gray-500 tw-text-xs tw-px-1 tw-font-medium">{countries[value]?.import?.dataSourceInfo?.total_count ? "(" + getInternationalNumberSystem(countries[value]?.import?.dataSourceInfo?.total_count ?? 0) + ")" : ""}</span>
                          </span>
                        </div>
                      </span>
                    </div>
                  );
                })}
            </div>
          </section>
        )}
        <div className="tw-sticky tw-bottom-0 tw-p-3 tw-bg-white tw-z-20 tw-border-t tw-border-gray-200">
          <div className="tw-flex tw-items-center tw-gap-1 tw-font-medium tw-text-xs">
            <Info className="tw-stroke-primary-purple-500 tw-w-4 tw-h-4" />
            On multiple selection, you would be redirected to Universal Search
          </div>
        </div>
      </div>
      {upsellModal && (
        <Suspense fallback={"loading"}>
          <UpSellModal
            planId={currentUserPlan}
            intelHeaderDataSource={intelHeaderDataSource}
            show={upsellModal}
            handleClose={() => {
              setUpsellModal(false);
              trademoTrackingEvents(trackingEventDictionary.datasetDropdownUpsellGetInTouchCancel, generateTrackingObject(dataSource ? dataSource : window.location.pathname, pathname, getUserActivePlan()));
            }}
          />
        </Suspense>
      )}
    </div>
  );
};

export default DataSource;
